import { fetchRepairDocumentUrl } from '../api';

// openRepairDocument resolves the signed URL for a repair's document and opens it in a new tab.
// Shared by the card row and the side panel; onError surfaces a toast at the call site.
export async function openRepairDocument(
  repairId: string,
  onError: () => void
): Promise<void> {
  try {
    const url = await fetchRepairDocumentUrl(repairId);
    window.open(url, '_blank', 'noopener,noreferrer');
  } catch {
    onError();
  }
}
